import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext({ home: {}, seo: {}, reload: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({ home: {}, seo: {} });
  const reload = useCallback(() => api.get("/content").then((r) => setContent(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return <ContentContext.Provider value={{ ...content, reload }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);

const fill = (s, vars) => Object.entries(vars).reduce((acc, [k, v]) => acc.split(`{${k}}`).join(v ?? ""), s || "");

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export function useSeo(page, vars = {}) {
  const { seo } = useContent();
  const key = JSON.stringify(vars);
  useEffect(() => {
    const title = fill(seo[`${page}_title`], vars) || seo.site_name;
    const desc = fill(seo[`${page}_description`], vars);
    if (title) document.title = title;
    if (desc) {
      setMeta("name", "description", desc);
      setMeta("property", "og:description", desc);
    }
    if (title) setMeta("property", "og:title", title);
  }, [seo, page, key]); // eslint-disable-line react-hooks/exhaustive-deps
}
